import React from "react";

const PortfolioWebCard = ({ projectName, tags, img }) => {
  return (
    <div className="bg-white bg-opacity-95 border-teal-200 border-[4px] rounded-lg p-4 mb-6 max-w-full max-h-full transition-transform duration-500 hover:scale-105 shadow-lg hover:shadow-2xl relative overflow-hidden">
    {/* Top Bar with Dots */}
    <div className="absolute top-2 left-6 m-3 flex space-x-1">
      <div className="w-3 h-3 bg-blue-800 border-black border-[2px] rounded-full" />
      <div className="w-3 h-3 bg-teal-600 border-black border-[2px] rounded-full" />
      <div className="w-3 h-3 bg-green-600 border-black border-[2px] rounded-full" />
    </div>
  
    {/* img Section */}
    <div className="flex justify-center items-center mt-6 bg-white bg-opacity-50 rounded-lg mb-4 overflow-hidden relative">
      <img
        src={img}
        alt="Illustration Design"
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
      />
    </div>
  
    {/* Project Name */}
    <h3 className="text-xl font-bold mb-6 text-teal-800 ml-2">{projectName}</h3>
  
    {/* <div className="flex flex-row flex-wrap gap-2 ml-2 overflow-hidden relative mx-4 mb-4">
        <div className="flex gap-2 animate-slide">
          {tags.map((tag, index) => (
            <span
              key={index}
              className="bg-teal-600 flex justify-center items-center mx-2 text-white rounded-full px-2 py-1 text-sm border transition-transform duration-300 whitespace-nowrap"
              style={{ minWidth: "fit-content" }}
            >
              {tag}
            </span>
          ))}
        </div>
      </div> */}
  </div>
  
  );
};

export default PortfolioWebCard;
